import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import ExternalLayout from '../../layout/External'
import { confirmSignUp, signIn } from '../../redux/actions/authentication'
import { RootState } from '../../redux/store'
import axios from 'axios'
import { useState } from 'react'
import jwtDecode from 'jwt-decode'
import { uploadToS3 } from '../../utils/UploadFile'
import Empty from '../../components/Display/Empty'
import EmailAnimation from '../../assets/animations/email-icon.json'
import { HiArrowLeft } from 'react-icons/hi'


const server = process.env.REACT_APP_SERVER_URL

const RegisterFifth = () => {
  const form = useForm()

  const dispatch = useDispatch()

  const history = useHistory()

  const { addAlert } = useSnackBars()

  const [loading, setLoading] = useState<boolean>(false)

  const userRegister = useSelector(
    (state: RootState) => state.auth.userRegisterProcess
  )

  const onSubmit = async ({ code }): Promise<void> => {
    setLoading(true)
    let s3InfoResponse : {value: any} = {value: {}}

    try {
      let response = await dispatch(confirmSignUp({ email: userRegister.email, code }))
      
      console.log("responsee...", response)
    } catch (err: any) {
      if (err.code === 'CodeMismatchException') {
        addAlert({
          message: 'Código incorrecto',
          status: 'error',
        })
      }
    }

    let date = new Date()
    date.setDate(date.getDate() + 3);
    let dateISO = date.toISOString()

    let subscriptionEnd = dateISO.replace(/T.+/, '')

    let body = {
      realName: userRegister.name,
      document: {
        documentType: userRegister.document.documentType,
        document: userRegister.document.document,
      },
      businessName: userRegister.businessName,
      email: userRegister.email,
      businessSocial: userRegister.businessSocial,
      plan: 'emprendedor',
      subscriptionEnd: subscriptionEnd,
      subscriptionType: 'MONTHLY',
      phone: userRegister.phone,
      address: {
        city: userRegister.city,
        postalCode: userRegister.postalCode,
        state: userRegister.state,
        country: userRegister.country,
      },
    }
    
    try {
      const result: any = await dispatch(
        signIn({ email: userRegister.email, password: userRegister.password })
      )
      console.log("response sign in...", result)
      let user : any = jwtDecode(result.access_token)
      if (userRegister.image) {
        await uploadToS3(userRegister.image, s3InfoResponse, undefined, user["custom:tenant_id"])
        console.log("s3 info response", s3InfoResponse)
      }

      if (result?.access_token) {
        history.push('/dashboard')
      }
      // history.push('/registro_sexto')
    } catch (err: any) {
      if (err.code === 'NotAuthorizedException') {
        addAlert({
          message: 'Usuario o Contraseña incorrecta',
          status: 'error',
        })
      }
      if (err.code === 'UserNotFoundException') {
        addAlert({
          message: 'Usuario no existente',
          status: 'error',
        })
      }
      if (err.code === 'UserNotConfirmedException') {
        addAlert({
          message: 'Usuario no confirmado',
          status: 'error',
        })
      }
    }

    try {
      await axios.post(`${server}/user/tenant`, {...body, image: `https://${s3InfoResponse.value.Bucket}.s3.amazonaws.com/${s3InfoResponse.value.Key}`})
    } catch (err) {
      addAlert({
        message: 'Error al crear el usuario.',
        status: 'error',
      })
    }
    setLoading(true)
  }

  return (
    <ExternalLayout>
      <h1 className="font-bold text-3xl text-coolGray-900 mb-2 dark:text-white text-center">
        Confirmación de correo electrónico
      </h1>

      {/* <p
        className="font-normal text-sm mb-2 text-primary-700 dark:text-primary-200 text-center"
        style={{ opacity: 0.5 }}
      >
        Paso 5 de 5
      </p> */}

      {/* <Form form={form} onSubmit={onSubmit}>
        <FormItem
          classes="col-span-12 my-2"
          name="code"
          rules={{
            pattern: {
              value: /^\d{6}$/,
              message: 'El código de confirmación es incorrecto',
            },
          }}
        >
          <InputText label="Código de confirmación" isUpperValue={false} />
        </FormItem>
        <Button
          type="primary"
          classes="col-span-12 mt-3 font-semibold tracking-wide"
          htmlType="submit"
          loading={loading}
          disabled={loading}
        >
          {loading ? 'Creando usuario' : 'Continuar'}
        </Button>
      </Form> */}
      <h1 className='font-bold text-2xl text-coolGray-900 mb-2 dark:text-white text-center'>Revisa tu bandeja. Te hemos enviado un correo electrónico de verificación.</h1>
      <Empty
          animationProps={{
            height: 250,
            width: 250,
            animation: EmailAnimation,
          }}
          lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
        >
          {/* <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
            Añade cuentas y comienza a llevar el mejor control de tus finanzas
          </p> */}
        </Empty>

      <div className='flex items-center mt-3' onClick={() => history.push('/ingresar')}>
        <HiArrowLeft size={30} className="text-primary mr-2" />
        <label className='text-primary'>Regresar al inicio de sesión</label>
      </div>
    </ExternalLayout>
  )
}

export default RegisterFifth
